import { render } from "./authComponent.vue?vue&type=template&id=5f51b612"
import script from "./authComponent.vue?vue&type=script&lang=js"
export * from "./authComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__